import "../../styles/CareerInfo.css";
import Calender from "../../assets/calender11.png";
import Share from "../../assets/Vector (23).png";
import Bag from "../../assets/bag.png";
import Profile from "../../assets/user-square-svgrepo-com 1.png";
import Salery from "../../assets/money-send-svgrepo-com 1.png";
import Mark from "../../assets/Info.png";

function CareerInfo({ career = {} }) {
   return (
      <div className="career-info">
         <div className="head">
            <h5>معلومات الوظيفة</h5>
            <div>
               <span className="date">
                  <img src={Calender} alt="" />
                  <span>{career?.created_at}</span>
               </span>
               <span className="share">
                  <img src={Share} alt="" />
                  مشاركة
               </span>
            </div>
         </div>
         <section>
            <div>
               <span>
                  <img src={Bag} alt="" />
                  الاختصاص
               </span>
               <span>{career?.["department name"]}</span>
            </div>

            <div>
               <span>
                  <img src={Profile} alt="" />
                  الخبرة
               </span>
               <span>{career?.experience}</span>
            </div>
            <div>
               <span>
                  <img src={Salery} alt="" />
                  الراتب
               </span>
               <span>{career?.salery}</span>
            </div>
            <div>
               <span>
                  <img src={Mark} alt="" />
                  طبيعة العمل
               </span>
               <span>{career?.["work type"]}</span>
            </div>
         </section>

         {/* <h6>ماهي مهامك ؟</h6> */}

         <div dangerouslySetInnerHTML={{ __html: career?.description }} />

         {/* <h6>ماهي متطلبات العمل ؟</h6>
         <div dangerouslySetInnerHTML={{ __html: career?.Work_requirements }} />

         <h6>ماذا نقدم :</h6>
         <div dangerouslySetInnerHTML={{ __html: career?.we_offer }} /> */}
      </div>
   );
}

export default CareerInfo;
